<template>
  <div class="px-2 lg:px-4 py-2">
    <PBreadcrumb :parts="parts" current-page-label="Données personnelles" />
    <div class="flex justify-around w-full py-6 lg:px-16 gap-4">
      <div class="flex flex-col gap-4 xl:w-[60%]">
        <h1 class="text-h1 font-bold">Données personnelles</h1>
        <div class="text-xl">
          <p>
            Le Parapheur est un système d'information de gestion dématérialisée du courrier inscrit au registre
            ministériel. Le traitement des données personnelles est fondé sur l'intérêt légitime du ministère et
            l'exercice d'une mission d'intérêt public.
          </p>
        </div>
        <div>
          <PAccordionGroup :group="false">
            <PAccordion
              :open="accordion1Opened"
              label="Données traitées pour les émetteurs ou destinataires des courriers"
              class="border-b border-grey-925"
              :class="{ 'mb-3': !accordion1Opened }"
              :version="2"
            >
              <ul class="pb-4">
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class="">
                    Les données relatives à l’état civil : nom, prénom, et, le cas échéant signature, numéro de
                    téléphone, adresse postale, etc,
                  </span>
                </li>
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class="">
                    les données professionnelles : adresse mail professionnelle, poste, fonction, entreprise,
                  </span>
                </li>
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class="">
                    les données relatives au courrier : objet et contenu de la demande ou du courrier, date du courrier,
                    réponse apportée, le cas échéant, pièces jointes.
                  </span>
                </li>
              </ul>
            </PAccordion>
            <PAccordion label="Données traitées pour les utilisateurs de la solution" :version="2">
              <ul class="pb-4">
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class=""> Les données d’état civil : nom, prénom, signature, </span>
                </li>
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class="">
                    les données professionnelles : adresse mail professionnelle, poste, entreprise,
                  </span>
                </li>
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class="">
                    les données d’utilisation de la solution : demandes reçues et traitées, historisation des
                    modifications et du suivi du courrier, statistiques d’usage,
                  </span>
                </li>
                <li class="flex items-center">
                  <OhVueIcon :name="dotIcon" scale="1.5" class="self-start" />
                  <span class=""> les données de connexion : logs d’accès et de connexion. </span>
                </li>
              </ul>
            </PAccordion>
          </PAccordionGroup>
        </div>
        <div>
          <span
            >Toutes les dispositions obligatoires pour la notice d'information sont disponibles dans les &nbsp;</span
          >
          <PLink :to="config.cguLink">CGU</PLink>
        </div>
      </div>
      <div class="hidden xl:block">
        <div class="w-[15rem] h-[15rem] bg-grey-975 rounded-full -skew-x-6 p-6">
          <div
            class="bg-no-repeat bg-cover bg-center w-full h-full skew-x-6"
            :style="`background-image: url(/lock.svg);`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PBreadcrumb, useConfig, useIcons, PAccordion, PAccordionGroup, PLink } from "@pasta/box-v2";
import { type ParapheurConfig } from "../types";
import { BiDot } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";
import { ref } from "vue";

const parts = [{ label: "Accueil", to: "/" }];

const config = useConfig<ParapheurConfig>();
const [dotIcon] = useIcons(BiDot);

const accordion1Opened = ref(false);
</script>
